import Stack from "@mui/material/Stack";
import Step from "@mui/material/Step";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { StepIconProps } from "@mui/material/StepIcon";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { styled } from "@mui/material/styles";
import moment from "moment";
import * as React from "react";
import {
  AccepteeIcon,
  ExpedieIcon,
  FeedBackIcon,
  HeartIcon,
  LivreeIcon,
  PayeeIcon,
  PlacedIcon,
} from "../../assets/images/FrankIcons";
import { defaultLabelColors } from "../../utils/constants";

const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme }) => ({
  backgroundColor: "#fff",
  zIndex: 1,
  color: "#fff",
  width: 50,
  //   height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
}));


const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  marginLeft: 25, // Adjust spacing to align properly

  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#EF6A31",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#EF6A31",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
    height: 50,
    ...theme.applyStyles("dark", {
      borderColor: "#A1AEBE",
    }),
  },
}));
function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <PlacedIcon />,
    2: <AccepteeIcon />,
    3: <PayeeIcon />,
    4: <ExpedieIcon />,
    5: <LivreeIcon />,
    6: <FeedBackIcon />,
    7: <HeartIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

export default function CustomizedSteppers(props: any) {
  const { order_array } = props;
  const firstEmptyIndex = order_array.findIndex(
    (step: any) => !step.created_at
  );

  return (
    <Stack sx={{ width: "100%" }} spacing={4}>
      <Stepper
        activeStep={
          firstEmptyIndex === -1 ? order_array?.length : firstEmptyIndex
        }
        orientation="vertical"
        connector={<ColorlibConnector  />}
      >
        {order_array.map((label: any) => (
          <Step key={label?.added_by}>
            <StepLabel
              StepIconComponent={(props) => (
                <div
                  style={{ filter: label?.active ? "none" : "grayscale(100%)" }}
                >
                  <ColorlibStepIcon {...props} />
                </div>
              )}
            >
              <div>
                <div
                  style={{
                    color: label?.active ? defaultLabelColors?.main_orange_new:"#465668",
                    fontFamily: "montserrat-SemiBold",
                    fontSize: 16,
                    // filter: label?.active ? "none" : "grayscale(100%)" ,
                  }}
                >
                  {label.status}
                </div>
                <div
                  style={{
                    color: "#A6A6A6",
                    fontFamily: "montserrat-Regular",
                    fontSize: 14,
                  }}
                >
                  {
                  label.status==="Merci"||label.status==="Laisser un commentaire"?"" : label?.active
                  ? moment(label?.created_at).format("DD MMM, YYYY h:mm A")
                  : ""}
                  {/* {!label?.created_at ||label?.created_at===""?"":moment(label?.created_at).format("DD MMM, YYYY h:mm A")} */}
                  
                 
                </div>
              </div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}
